import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=797f1a1f&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=797f1a1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797f1a1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('797f1a1f')) {
      api.createRecord('797f1a1f', component.options)
    } else {
      api.reload('797f1a1f', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=797f1a1f&scoped=true&", function () {
      api.rerender('797f1a1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zkBf8K3p8CQo/JS/comp/PopupDialog.vue"
export default component.exports